// Generated by scripts/build-ui-icons.mjs.
export { Gear as default } from "../ui/glyphs-4";
